import React from 'react'
import { Skeleton, useViewport } from '@chilecompra/react-kit'

/**
 * The Manage Participant loading component.
 */
const ManageParticipantsLoading = () => {
  const {
    size: { isUpToMedium }
  } = useViewport()

  return (
    <>
      <Skeleton height="585px" margin="2.5rem 0 2rem" variant="rect" width={isUpToMedium ? '70%' : '100%'} />
      <Skeleton
        height="585px"
        margin={!isUpToMedium ? '0 0 2rem' : '2.5rem 0 2rem 2rem'}
        variant="rect"
        width={isUpToMedium ? '26%' : '100%'}
      />
    </>
  )
}

export default ManageParticipantsLoading
